import { NotificationType } from '@/features/notifications/notification-service-extension-shared/constants/app'

export const notificationTypes = {
    [NotificationType.AwaitingAcceptanceOrder]: 'Objednávka čeká na přijetí',
    [NotificationType.AcceptedOrder]: 'Přijatá objednávka',
    [NotificationType.PostponedOrder]: 'Odložená objednávka',
}
